import { render } from "./About.vue?vue&type=template&id=e71b37f0&scoped=true"
import script from "./About.js?vue&type=script&lang=js"
export * from "./About.js?vue&type=script&lang=js"

import "./About.scss?vue&type=style&index=0&id=e71b37f0&lang=scss&scoped=true"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e71b37f0"]])

export default __exports__